import XocsCore from 'react-xocs/dist/xocs-core';
import { skip, node, nodeWithId } from 'react-xocs/dist/xocs/xocs-core';
import para from 'react-xocs/dist/xocs/para';
import math from 'react-xocs/dist/math/';
import list from 'react-xocs/dist/xocs/list';
import sectionTitle from '../section-title';
import link from '../link';
import attachments from '../attachments';

const label = node('dt', { className: 'label' });

const components = {
  'section-title': sectionTitle,
  math,
  para,
  'simple-para': para,
  'note-para': para,
  'cross-ref': skip,
  abstracts: skip,
  abstract: skip,
  'abstract-sec': skip,
  label,
  anchor: nodeWithId('span'),
  display: nodeWithId('span'),
  figure: node('figure', { className: 'u-margin-ver-xs' }),
  link,
  attachments,
  list,
};

const overrides = { label };

export default function Abstract(content = {}) {
  const variables = { assetCdnUrl: window.config.assetCdnUrl };
  return Object.keys(content).length ? (
    <div className="u-margin-ver-m from-xocs branded" key={0}>
      {XocsCore({
        content, components, overrides, variables,
      })}
    </div>
  ) : null;
}
